import library_fr from "@nuxtDatakodeUtils/lang/fr";
import lang_fr from "@/lang/fr";
function customMerge(obj1, obj2) {
	const merged = { ...obj1 };
	for (const key in obj2) {
		if (Object.prototype.hasOwnProperty.call(obj2, key)) {
			merged[key] = obj1[key] && obj1[key].toString() === "[object Object]" ? customMerge(obj1[key], obj2[key]) : obj2[key];
		}
	}
	return merged;
}
const frMessages = customMerge(library_fr, lang_fr);
export default () => ({
	missingWarn: false,
	fallbackWarn: false,
	silentTranslationWarn: true,
	warnHtmlMessage: false,
	locale: "fr",
	runtimeOnly: false,
	messages: { fr: frMessages }
});
